export const CONTAINER = {
  login: 'login',
  signup: 'signup',
  recovery: 'recovery',
};
